/* ══════════════════════════════════════════════════════════════════
   D.C.WHITE ダークモード切替 2026-08-21
   - 初期適用は theme.liquid <head> のインラインスクリプト（FOUC防止）。
     ここはトグル操作・OS設定追従・meta theme-color 同期を担当
   - 保存キー: localStorage 'dcw-theme'（'dark' | 'light'）
     未保存なら OS の prefers-color-scheme に追従し続ける
   ══════════════════════════════════════════════════════════════════ */
(function () {
  var KEY = 'dcw-theme';
  var META_LIGHT = '#ffffff';
  var META_DARK = '#142134';
  var root = document.documentElement;
  var animTimer = null;

  function isDark() {
    return root.getAttribute('data-theme') === 'dark';
  }

  function stored() {
    try {
      return localStorage.getItem(KEY);
    } catch (e) {
      return null;
    }
  }

  /* モバイルブラウザのアドレスバー色を追従させる */
  function paintMeta() {
    var meta = document.querySelector('meta[name="theme-color"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'theme-color';
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', isDark() ? META_DARK : META_LIGHT);
  }

  /* ページ内すべてのトグル（ヘッダー/ドロワー）の状態・ラベルを揃える */
  function syncControls() {
    var dark = isDark();
    var toggles = document.querySelectorAll('[data-theme-toggle]');
    for (var i = 0; i < toggles.length; i++) {
      var btn = toggles[i];
      btn.setAttribute('aria-checked', dark ? 'true' : 'false');
      var label = dark ? btn.getAttribute('data-label-to-light') : btn.getAttribute('data-label-to-dark');
      if (label) btn.setAttribute('aria-label', label);
    }
  }

  function apply(theme, persist) {
    root.setAttribute('data-theme', theme);
    if (persist) {
      try {
        localStorage.setItem(KEY, theme);
      } catch (e) {
        /* プライベートブラウズ等で保存不可でも切替自体は成立させる */
      }
    }
    paintMeta();
    syncControls();
  }

  /* クリックは委譲で拾う（セクション再描画でもリスナーが切れない） */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-theme-toggle]');
    if (!btn) return;
    /* 切替の瞬間だけ全体トランジションを有効化（dark-mode.css 9) */
    root.classList.add('theme-switching');
    clearTimeout(animTimer);
    animTimer = setTimeout(function () {
      root.classList.remove('theme-switching');
    }, 450);
    var next = isDark() ? 'light' : 'dark';
    apply(next, true);
    track('dark_mode_toggle', { to_mode: next });
  });

  /* 手動選択が無いうちは OS 設定の変化に追従（夜に自動で暗くなる） */
  var mq = window.matchMedia('(prefers-color-scheme: dark)');
  var onOsChange = function (ev) {
    if (!stored()) apply(ev.matches ? 'dark' : 'light', false);
  };
  if (mq.addEventListener) mq.addEventListener('change', onOsChange);
  else if (mq.addListener) mq.addListener(onOsChange); /* 旧Safari */

  /* ── チェックアウト遷移のフェードブリッジ v2 ─────────────────
     夜の暗所で「濃紺 → 白いチェックアウト」の急な輝度ジャンプを、白への
     ディゾルブに変える（チェックアウト自体はShopify管理領域でダーク化不可）。

     v1は「遷移中の旧ページにフェードを重ねる」方式だったが、実機の
     Safari/Chromeはナビゲーション開始とほぼ同時に旧ページの描画を凍結する
     ため、フェードが1フレームも描かれず知覚できなかった（2026-08-21実測）。
     v2は順序を逆転: フェードを先に再生し、160ms後（ease-outで約8割白）に
     本来のsubmit/遷移を開始する。ブラウザの遷移中描画に依存しない。
     追加レイテンシは約160msで、ラグではなくトランジションとして知覚される帯域 */
  var fadePending = false;

  /* v3（2026-08-21）: フェードを「完走させてから」遷移を開始する。
     - v2の160ms先行開始は、ナビゲーション開始と同時の描画凍結でフェードの
       可視部分が圧縮され、実機では知覚できなかった
     - v3は280msのディゾルブを最後まで見せる→凍結する瞬間の画面は真っ白
       ＝チェックアウトの白と同一なので、カット切替そのものが消える
     - CSS transitionでなくWeb Animations APIを使う（挿入直後の要素でも
       確実に始動し、onfinishで完了を取れる）
     - prefers-reduced-motion では無効化しない: 動きのない輝度クロスフェードは
       iOS自身がReduce Motion時に代替として使う表現（配慮として正しい側） */
  function startCheckoutFade(proceed) {
    var done = false;
    var go = function () {
      if (done) return;
      done = true;
      proceed();
    };
    var ov = document.getElementById('dcw-checkout-fade');
    if (!ov) {
      ov = document.createElement('div');
      ov.id = 'dcw-checkout-fade';
      ov.setAttribute('aria-hidden', 'true');
      ov.style.cssText =
        'position:fixed;inset:0;background:#fff;opacity:0;pointer-events:none;' +
        'z-index:2147483647;';
      document.body.appendChild(ov);
    }
    try {
      var anim = ov.animate(
        [{ opacity: 0 }, { opacity: 1 }],
        { duration: 280, easing: 'ease-out', fill: 'forwards' }
      );
      anim.onfinish = go;
    } catch (e) {
      ov.style.opacity = '1'; /* WAAPI非対応: 即白→下のフォールバックで遷移 */
    }
    setTimeout(go, 340); /* onfinishが来ない環境でも遷移を保証する保険 */
    /* 万一遷移が始まらなかった場合に白幕が残り続けないように */
    setTimeout(function () {
      var stale = document.getElementById('dcw-checkout-fade');
      if (stale) stale.remove();
      fadePending = false;
    }, 8000);
  }

  document.addEventListener(
    'click',
    function (e) {
      if (!isDark()) return;
      var el = e.target.closest && e.target.closest('button[name="checkout"], a[href*="/checkout"]');
      if (!el) return;
      if (fadePending) {
        e.preventDefault(); /* フェード中の二度押しは無視（遷移は進行中） */
        return;
      }
      if (el.tagName === 'BUTTON') {
        var form = el.form;
        /* requestSubmit(submitter)が無い旧環境では介入しない
           （form.submit()では name=checkout が付かず決済に進めないため、
           その場合は素のsubmitに任せる=フェード無しのカット切替） */
        if (!form || typeof form.requestSubmit !== 'function') return;
        e.preventDefault();
        fadePending = true;
        startCheckoutFade(function () {
          try {
            form.requestSubmit(el);
          } catch (err) {
            window.location.assign('/checkout'); /* 最終フォールバック */
          }
        });
      } else {
        var href = el.href;
        e.preventDefault();
        fadePending = true;
        startCheckoutFade(function () {
          window.location.assign(href);
        });
      }
    },
    true /* capture: 他スクリプトがstopPropagationしても拾う */
  );

  /* 戻るボタン(bfcache)で旧ページに復帰したとき白幕が残らないように */
  window.addEventListener('pageshow', function () {
    fadePending = false;
    var ov = document.getElementById('dcw-checkout-fade');
    if (ov) ov.remove();
  });

  /* テーマエディタのセクション再読込後にトグル状態を復元 */
  document.addEventListener('shopify:section:load', syncControls);

  /* ── GA4計測（sticky_atc_add と同じ流儀: gtag直呼び・無ければ黙る）──
     dark_mode_state : ページ表示ごとに現モードを記録（mode, mode_source）。
       ダーク勢/ライト勢のセッション別CVR比較の分母になる
     dark_mode_toggle: トグル操作（to_mode）。機能の利用率を見る
     gtagはGoogle公式ピクセルが後から公開するので、状態イベントだけ
     最大5回リトライして待つ（それでも無ければ諦める＝全イベント同条件） */
  var GA_ID = 'G-YJ53NB0E09';

  function track(name, params) {
    try {
      if (typeof window.gtag === 'function') {
        params.send_to = GA_ID;
        window.gtag('event', name, params);
        return true;
      }
    } catch (e) { /* 計測失敗は体験に影響させない */ }
    return false;
  }

  var stateTries = 0;
  function sendState() {
    var sent = track('dark_mode_state', {
      mode: isDark() ? 'dark' : 'light',
      /* 2026-09-17: 名前を source → mode_source に変更。
         GA4 は source を「流入元」の予約名として扱い、セッションの参照元を
         "os"/"user" に上書きしていた（8/27〜のチャネル集計が崩れた原因） */
      mode_source: stored() ? 'user' : 'os'
    });
    if (!sent && ++stateTries < 5) setTimeout(sendState, 2500 * stateTries);
  }
  sendState();

  paintMeta();
  syncControls();
})();
